module.exports = __webpack_public_path__ + "img/money-sign.57c8c590.svg";